import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 50 20"
      preserveAspectRatio="xMinYMin slice"
      fill="none"
      {...props}
    >
      <Path
        d="M48.656 0H0v20h48.656a1 1 0 00.958-1.287l-2.442-8.138a2 2 0 010-1.15l2.442-8.138A1 1 0 0048.656 0z"
        fill="#00BA65"
      />
    </Svg>
  );
}

export default SvgComponent;
